import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared';
import { Core2Config } from '../shared';
import {InventoryPdgElementImportFileHelper} from '../../../../../models/aggregates/inventory-pdg';

@Injectable({
  providedIn: 'root'
})
export class InventoryPdgElementImportFileHelperService extends BaseApiTemplateService<InventoryPdgElementImportFileHelper> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-element/import-file-helpers/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-element/import-file-helpers/' +  Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}